<script lang="ts">
import omit from 'lodash.omit'

import type { Props as SvgHelperProps } from './SvgHelper.vue'

export type SupportedCountryCode = 'FI' | 'GB' | 'GB-ENG' | 'GB-NIR' | 'GB-SCT' | 'GB-WLS' | 'DE' | 'SE' | 'PL'
</script>

<script lang="ts" setup>
const props = defineProps<SvgHelperProps & {
  /** ISO 3166-2 */
  countryCode?: SupportedCountryCode
  language?: App.Internals.Enums.Language
}>()

const svgHelperProps = computed(() => omit(props, ['countryCode', 'language']))

const mappedFlagName = computed<SupportedCountryCode>(() => {
  if (props.countryCode)
    return props.countryCode

  switch (props.language) {
    case 'de':
      return 'DE'
    case 'en':
      return 'GB'
    case 'fi':
      return 'FI'
    case 'sv':
      return 'SE'
    case 'pl':
      return 'PL'
    default:
      throw new Error('Missing mapped language!')
  }
})

const img = computedAsync<string>(async () =>
  (await import(`~/assets/images/flags/${mappedFlagName.value}.svg?url`)).default,
)
</script>

<template>
  <SvgHelper
    #default="{ attributes }"
    v-bind="svgHelperProps"
  >
    <img
      :alt="countryCode"
      :src="img"
      v-bind="attributes"
    >
  </SvgHelper>
</template>
